import React from 'react'
import { Link } from 'react-router-dom'
import Constant from '../../Constant.js'
import Swal from 'sweetalert2'
import axios from 'axios'

class invoicePrint extends React.Component {
  state = {
    booking_data: {},
  }
  componentDidMount() {
    this.getBookingList()
  }
  getBookingList = async () => {
    var that = this
    var data = {
      booking_id: this.props.match.params.booking_id,
    }
    await axios
      .post(Constant.getAPI() + '/booking/checkout-payment', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          that.setState({
            booking_data: res.data.data,
          })
          var mappeddate = []
          if (res.data?.data?.timeSlots) {
            mappeddate = res.data?.data?.timeSlots?.map((itm) => parseInt(itm.slot_from.split(':')?.[0]))
            mappeddate.sort(function (a, b) {
              return a - b
            })
            var timeStart = []
            var dummy = ':00, '
            for (let i = 0; i < mappeddate.length; i++) {
              timeStart.push(mappeddate[i] + dummy)
            }
          }
          var mapdata = []
          if (res.data?.data?.timeSlots) {
            mapdata = res.data?.data?.timeSlots?.map((itm) => parseInt(itm.slot_to.split(':')[0]))
            mapdata.sort(function (a, b) {
              return b - a
            })
          }
          that.setState({
            timeData: timeStart,
            timeData1: mapdata?.[0],
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }
  onPrint = () => {
    var that = this

    window.onbeforeprint = function () {
      document.getElementById('admin_menu').classList.remove('pcoded-navbar')
      document.getElementById('admin_content').classList.remove('pcoded-content')
      document.title = `invoice - #${that.props.match.params.booking_id}`
    }
    window.onafterprint = function () {
      document.getElementById('admin_menu').classList.add('pcoded-navbar')
      document.getElementById('admin_content').classList.add('pcoded-content')
      document.title = 'Waves'
    }
    window.print()
  }
  render() {
    return (
      <div className="">
        <div id="print-area">
          <div className="row">
            <div className="col-md-3">
              <div className="invoice-box row">
                <div className="col-sm-12">
                  <table className="table table-responsive invoice-table table-borderless">
                    <tbody>
                      <tr>
                        <td>
                          <img
                            src="./assets/images/icon.png"
                            className="m-b-10 img-100"
                            alt=""
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          {this.state.booking_data ? (
            <div
              className="card-block"
              id="print_invoice"
            >
              <div className="row invoive-info">
                <div className="col-md-4 col-xs-12 invoice-client-info">
                  <h6>Client Information</h6>
                  <h6 className="m-0">
                    {this.state.booking_data?.clientDetails?.first_name}{' '}
                    {this.state.booking_data?.clientDetails?.last_name}{' '}
                  </h6>
                  <p className="m-0">Email : {this.state.booking_data?.clientDetails?.email}</p>
                  <p className="m-0">Contact Number : {this.state.booking_data?.clientDetails?.phone}</p>
                  <p className="m-0">Country Code : {this.state.booking_data?.clientDetails?.country_code}</p>
                </div>
                {/* <div className="col-md-4 col-sm-6">
                                <h6>order Information :</h6>
                                <table className="table table-responsive invoice-table invoice-order table-borderless">
                                    <tbody>
                                        <tr>
                                            <th>Order Date :</th>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <th>Order Time :</th>
                                            <td>time</td>
                                        </tr>

                                    </tbody>
                                </table>
                            </div> */}
                <div className="col-md-4 col-sm-6"></div>
                <div className="col-md-4 col-sm-6">
                  <h6 className="m-b-20">
                    Transaction ID :<span> {this.state.booking_data?.transactionDetails?.txn_id}</span>
                  </h6>

                  {this.state.booking_data?.transactionDetails?.payment_status === 'PAID' ? (
                    <h6 className="text-uppercase text-primary">
                      Payment Status : <span className="badge badge-success">Success</span>
                    </h6>
                  ) : (
                    <h6 className="text-uppercase text-primary">
                      Payment Status : <span className="badge badge-danger"> Pending </span>
                    </h6>
                  )}
                  <h6 className="text-uppercase text-primary">
                    Payment Method ID : <span> {this.state.booking_data?.transactionDetails?.payment_method_Id}</span>
                  </h6>
                  <h6 className="text-uppercase text-primary">
                    Payment ID : <span> {this.state.booking_data?.transactionDetails?.payment_id}</span>
                  </h6>
                  <h6 className="text-uppercase text-primary">
                    Payment Currency : <span> {this.state.booking_data?.transactionDetails?.payment_currency}</span>
                  </h6>
                  <h6 className="text-uppercase text-primary">
                    Payment Amount : <span> {this.state.booking_data?.transactionDetails?.payment_amount}</span>
                  </h6>
                </div>
              </div>
              <div className="row invoive-info">
                <div className="col-md-4 col-sm-6 ">
                  <h6 className="text-uppercase">Captain Details</h6>
                  {/* <h6 className=" text-primary">
                                        Profile :  <img
                                            src={
                                                this.state.booking_data?.captain?.captainProfileImg !== undefined && this.state.booking_data?.captain?.captainProfileImg !== null && this.state.booking_data?.captain?.captainProfileImg !== {}
                                                    ? Constant.getImage() + this.state.booking_data?.captain?.captainProfileImg
                                                    : "./assets/images/icon.png"
                                            }
                                            className="img-fluid img-40"
                                            alt="tbl"
                                        /> </h6> */}
                  <h6 className=" text-primary">
                    Name :{' '}
                    <span>
                      {' '}
                      {this.state.booking_data?.captain?.first_name} {this.state.booking_data?.captain?.last_name}
                    </span>
                  </h6>
                  <h6 className=" text-primary">
                    Email: <span> {this.state.booking_data?.captain?.email}</span>
                  </h6>
                  <h6 className=" text-primary">
                    Phone: <span> {this.state.booking_data?.captain?.phone}</span>
                  </h6>
                  <h6 className=" text-primary">
                    Country Code: <span> {this.state.booking_data?.captain?.country_code}</span>
                  </h6>
                </div>
                <div className="col-md-4 col-sm-6 ">
                  <h6 className="text-uppercase">Destination Details</h6>

                  <h6 className=" text-primary">
                    Latitude : <span> {this.state.booking_data?.destination?.destination_lat}</span>
                  </h6>
                  <h6 className=" text-primary">
                    Longitude : <span> {this.state.booking_data?.destination?.destination_long}</span>
                  </h6>
                  <h6 className=" text-primary">
                    Address :<span> {this.state.booking_data?.destination?.destination_address}</span>
                  </h6>
                  <h6 className=" text-primary">
                    Minimum Hours : <span> {this.state.booking_data?.destination?.destination_min_hour}</span>
                  </h6>
                </div>
                <div className="col-md-4 col-sm-6 ">
                  <h6 className="text-uppercase">Payment summary</h6>

                  <h6 className=" text-primary">
                    cruise name : <span> {this.state.booking_data?.paymentSummary?.cruise_name}</span>
                  </h6>
                  {this.state.booking_data?.paymentSummary?.payment_status === true ? (
                    <h6 className="text-uppercase text-primary">
                      Payment Status : <span className="badge badge-success">Success</span>
                    </h6>
                  ) : (
                    <h6 className="text-uppercase text-primary">
                      Payment Status : <span className="badge badge-danger"> Pending </span>
                    </h6>
                  )}
                  <h6 className=" text-primary">
                    Service Charge : <span> {this.state.booking_data?.paymentSummary?.service_charge}</span>
                  </h6>
                  <h6 className=" text-primary">
                    Tax Amount : <span> {this.state.booking_data?.paymentSummary?.tax_per}</span>
                  </h6>
                  <h6 className=" text-primary">
                    Toatl Booking Amount : <span> {this.state.booking_data?.paymentSummary?.total_booking_amount}</span>
                  </h6>
                </div>
              </div>
              <div className="col-md-4 col-sm-6  ">
                <h6 className="text-uppercase">PickUp Details</h6>

                <h6 className=" text-primary">
                  Latitude : <span> {this.state.booking_data?.pickUp?.pickup_lat}</span>
                </h6>
                <h6 className=" text-primary">
                  Longitude : <span> {this.state.booking_data?.pickUp?.pickup_long}</span>
                </h6>
                <h6 className=" text-primary">
                  Address : <span> {this.state.booking_data?.pickUp?.pickup_address}</span>
                </h6>
                <h6 className=" text-primary">
                  Description : <span> {this.state.booking_data?.pickUp?.pickup_desc}</span>
                </h6>
                <h6 className=" text-primary">
                  Map :<span> {this.state.booking_data?.pickUp?.pickup_map}</span>
                </h6>
                <h6 className=" text-primary">
                  Other Details : <span> {this.state.booking_data?.pickUp?.pickup_other_detail}</span>
                </h6>
              </div>
              {this.state.booking_data?.paymentSummary?.diwaniyaItemsList?.length ? (
                <div className="row">
                  <div className="col-sm-12">
                    <div className="table-responsive">
                      <h6 className="text-uppercase">Diwaniya</h6>
                      <table className="table">
                        <col width="150" />
                        <col width="150" />
                        <col width="150" />
                        <col width="150" />
                        <col width="150" />
                        <thead>
                          <tr className="thead-inverse">
                            <th style={{ textAlign: 'center' }}>No</th>
                            <th style={{ textAlign: 'center' }}>Item Name</th>
                            <th style={{ textAlign: 'center' }}>Quantity</th>
                            <th style={{ textAlign: 'center' }}>Item Name</th>
                            <th style={{ textAlign: 'center' }}>Payment status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.booking_data?.paymentSummary?.diwaniyaItemsList?.map((itm, ind) => (
                            <tr>
                              <td>
                                <h6 style={{ textAlign: 'center' }}>{ind + 1}</h6>
                              </td>
                              <td>
                                <h6 style={{ textAlign: 'center' }}>{itm.item_name}</h6>
                              </td>
                              <td>
                                <h6 style={{ textAlign: 'center' }}>{itm.item_qty}</h6>
                              </td>
                              <td>
                                <h6 style={{ textAlign: 'center' }}>{itm.amount}</h6>
                              </td>
                              <td>
                                {itm.payment_status === true ? (
                                  <span className="badge badge-success">Success</span>
                                ) : (
                                  <span className="badge badge-danger"> Pending </span>
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              ) : null}
              {this.state.booking_data.timeSlots?.length ? (
                <div className="col-md-4 col-sm-6 ">
                  <h6 className="text-uppercase">TimeSlots</h6>

                  <tr>
                    <td>
                      <p>
                        <label style={this.myStyle}>Slots from - Slots to</label>
                        <br />
                        {this.state.timeData}
                        {this.state.timeData1}
                        {':00 '}
                        <br />
                      </p>
                    </td>
                  </tr>
                </div>
              ) : null}
              {/* {this.state.booking_data.timeSlots?.length ?
                                <div className="row">
                                    <div className="col-sm-12">
                                        <div className="table-responsive">
                                            <h6 className="text-uppercase">
                                                TimeSlots
                                            </h6>
                                            <table className="table">
                                                <col width="250" />
                                                <col width="250" />
                                                <col width="250" />
                                                <thead>
                                                    <tr className="thead-inverse">
                                                        <th style={{ textAlign: "center" }}>No</th>
                                                        <th style={{ textAlign: "center" }}>Slot From</th>
                                                        <th style={{ textAlign: "center" }}>Slot End</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.booking_data?.timeSlots?.map((itm, ind) =>
                                                        <tr>
                                                            <td>
                                                                <h6 style={{ textAlign: "center" }}>{ind + 1}</h6>
                                                            </td>
                                                            <td>
                                                                <h6 style={{ textAlign: "center" }}>{itm.slot_from}</h6>

                                                            </td>
                                                            <td>
                                                                <h6 style={{ textAlign: "center" }}>{itm.slot_to}</h6>

                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                : null} */}
            </div>
          ) : null}
        </div>
        <div className="row text-center noprint">
          <div className="col-sm-12 invoice-btn-group text-center">
            <button
              onClick={() => this.onPrint()}
              className="btn btn-sm btn-print-invoice btn-inverse waves-effect waves-light d-inline-block md-trigger"
            >
              <i className="icofont icofont-print m-r-5"></i> Print{' '}
            </button>
            <Link
              to="/booking-order-v2"
              type="button"
              className="btn btn-danger waves-effect m-b-10 btn-sm m-1 waves-light"
            >
              Back
            </Link>
          </div>
        </div>
      </div>
    )
  }
}

export default invoicePrint
